import Feature34 from './Feature34'
export default Feature34
